import React from 'react'

import { withStyles } from "@material-ui/core/styles";

import IconButton from '@material-ui/core/IconButton'
import Visibility from "@material-ui/icons/Visibility"
import Edit from "@material-ui/icons/Edit"
import Delete from "@material-ui/icons/Delete"
import Table from "components/Table/Table.js"
import Card from "components/Card/Card.js"
import CardHeader from "components/Card/CardHeader.js"
import CardBody from "components/Card/CardBody.js"
import Circular from "components/Circular/Circular"
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContentText from '@material-ui/core/DialogContentText'
import Button from 'components/CustomButtons/Button.js'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem';
import CustomInput from "components/CustomInput/CustomInput.js"

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import GridItem from "components/Grid/GridItem.js"
import GridContainer from "components/Grid/GridContainer.js"

import { createEvent } from "../../services/events/events";
import { getAllLockersSelect } from "../../services/lockers/lockers";
import { getAllUsersGrid, saveUser, updateUser, deleteUser } from "../../services/users/users";
import { createBrowserHistory } from "history";

class Usuarios extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            id: '',
            nome: '',
            cpf: '',
            email: '',
            lockers: [],
            perfil: '',
            senha: '',
            telefone: '',
            matricula: '',

            load: true,
            loadSave: false,

            openModal: false,
            openModalDelete: false,
            userDeleteSelected: undefined,

            dataLockersGrid: [],
            dataLockers: [],
            dataGrupos: [],
            dataRoles: [],
            data: [],

            showSave: true,
            modoEdit: false,

            showValidation: false,

            currentUser: JSON.parse(localStorage.getItem("user")).data
        }

        this.onNovo = this.onNovo.bind(this)
        this.onCancel = this.onCancel.bind(this)
        this.onEditar = this.onEditar.bind(this)
        this.onSave = this.onSave.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.onDeleteItemGridLockersUser = this.onDeleteItemGridLockersUser.bind(this)
        this.onBuscaDados = this.onBuscaDados.bind(this)
    }

    async componentDidMount() {

        if (this.props.lockerId !== undefined) {
            this.setState({ modoEdit: true })
        }

        this.onBuscaDados()
    }

    onBuscaDados = async () => {

        getAllLockersSelect((data) => {

            this.setState({
                dataLockers: data.listLockers,
                dataGrupos: data.listGrupos
            })

            getAllUsersGrid({
                lockerId: this.props.lockerId
            }, (data) => {

                if (data.length === 0) {
                    this.setState({ load: false })
                    return
                }

                let indexCurrent = data.users.findIndex(g => this.state.currentUser.id === g.id);

                if (indexCurrent) {
                    let temp = data.users[indexCurrent];
                    data.users[indexCurrent] = data.users[0];
                    data.users[0] = temp;
                }

                data.users = data.users.filter(u => u && u.role?.name !== "Aplicativo");

                const grid = data.users.map(item => {
                    return [
                        item.name,
                        item.email,
                        item.role.name,
                        item.matricula,
                        <>
                            {
                                (!this.state.modoEdit && this.state.currentUser.id !== item.id) ?
                                    <>
                                        <IconButton aria-label="view" onClick={() => this.onEditar(item)}>
                                            <Edit className={this.props.classes.iconView} />
                                        </IconButton>
                                        <IconButton aria-label="view" onClick={() => this.setState({
                                            openModalDelete: true,
                                            userDeleteSelected: item
                                        })}>
                                            <Delete className={this.props.classes.iconView} />
                                        </IconButton>
                                    </> : undefined
                            }
                            <IconButton aria-label="view" onClick={() => this.onShow(item)}>
                                <Visibility className={this.props.classes.iconView} />
                            </IconButton>
                        </>
                    ]
                })

                this.setState({
                    load: false,
                    data: grid,
                    dataRoles: data.roles.filter(r => r.label !== "Aplicativo"),
                })
            })
        })

    }

    onNovo = () => {
        this.setState({
            id: '',
            nome: '',
            cpf: '',
            email: '',
            lockers: [],
            grupos: [],
            perfil: '',
            senha: '',
            telefone: '',
            matricula: '',
            openModal: true,
            showSave: true,

            dataLockersGrid: [],
            dataGruposGrid: [],
        })
    }

    onCancel = () => {
        this.setState({ openModal: false })
    }

    onDelete = () => {

        if (this.state.userDeleteSelected !== undefined) {
            deleteUser(this.state.userDeleteSelected.id, data => {

                const newData = this.state.data.filter(item => item[0] !== this.state.userDeleteSelected.name)
                this.setState({
                    data: newData,
                    openModalDelete: false
                });

                let d = {
                    'code': '102',
                    'usuario': this.state.currentUser.name,
                    'complemento': `Usuário ${this.state.nome} excluído`
                };

                createEvent(d, () => {
                    console.log("User", `Creted event`);
                });
            })
        }
    }

    onEditar = async (item) => {

        this.setState({
            id: item.id,
            nome: item.name,
            cpf: item.cpf,
            email: item.email,
            senha: '',
            lockers: [],
            grupos: [],
            perfil: item.roleId,
            telefone: item.phone,
            matricula: item.matricula,
            openModal: true,
            showSave: true,
            dataLockersGrid: item.lockers,
            dataGruposGrid: item.grupos
        })
    }

    onShow = async (item) => {

        console.log("User RoleID", item.roleId);

        this.setState({
            id: item.id,
            nome: item.name,
            cpf: item.cpf,
            email: item.email,
            senha: '',
            lockers: [],
            perfil: item.roleId,
            telefone: item.phone,
            matricula: item.matricula,
            openModal: true,
            showSave: false,
            dataLockersGrid: item.lockers,
            dataGruposGrid: item.grupos
        })
    }

    onSave = async () => {

        this.setState({ loadSave: true })

        if (this.state.id.length === 0) {
            saveUser({
                id: this.state.id,
                name: this.state.nome,
                email: this.state.email,
                password: this.state.senha,
                roleId: this.state.perfil,
                cpf: this.state.cpf,
                phone: this.state.telefone,
                matricula: this.state.matricula,
                lockers: this.state.dataLockersGrid,
                grupos: this.state.dataGruposGrid
            }, (data) => {

                if (data.message) {

                    this.setState({ showValidation: true })

                    setTimeout(() => {
                        this.setState({ showValidation: false })
                    }, 3000);

                    return
                }

                let d = {
                    'code': '100',
                    'usuario': this.state.currentUser.name,
                    'complemento': `Usuário ${this.state.nome} adicionado`
                };

                createEvent(d, () => {
                    console.log("User", `Creted event`);
                });

                this.setState({ loadSave: false, openModal: false })
                this.onBuscaDados()
            })
        }
        else {
            updateUser(
                this.state.id,
                {
                    name: this.state.nome,
                    email: this.state.email,
                    password: this.state.senha.length > 0 ? this.state.senha : undefined,
                    roleId: this.state.perfil,
                    cpf: this.state.cpf,
                    phone: this.state.telefone,
                    matricula: this.state.matricula,
                    lockers: this.state.dataLockersGrid,
                    grupos: this.state.dataGruposGrid,
                },
                (data) => {

                    if (data.message) {
                        this.setState({ showValidation: true })

                        setTimeout(() => {
                            this.setState({ showValidation: false })
                        }, 3000);

                        return
                    }

                    let d = {
                        'code': '101',
                        'usuario': this.state.currentUser.name,
                        'complemento': `Usuário ${this.state.nome} atualizado`
                    };

                    createEvent(d, () => {
                        console.log("User", `Creted event 2`);
                    });

                    this.setState({ loadSave: false, openModal: false })
                    this.onBuscaDados()
                }
            )
        }
    }

    onDeleteItemGridLockersUser = (locker) => {

        const newGrid = this.state.dataLockersGrid.filter(item => item.value !== locker.value)
        this.setState({ dataLockersGrid: newGrid })
    }

    onDeleteItemGridGrupoUser = (grupo) => {

        const newGrid = this.state.dataGruposGrid.filter(item => item.value !== grupo.value)
        this.setState({ dataGruposGrid: newGrid })
    }

    render() {
        if (!localStorage.getItem("user")) {
            createBrowserHistory({ forceRefresh: true }).push("/");
        } else {
            createBrowserHistory({ forceRefresh: false }).push(`/`);
        }

        return (

            <GridContainer>

                {
                    !this.state.modoEdit ?
                        <Card>
                            <CardHeader color="primary">
                                <h4 className={this.props.classes.cardTitleWhite}>Usuários</h4>
                                <p className={this.props.classes.cardCategoryWhite}>Usuários cadastrados</p>
                            </CardHeader>

                            <CardBody>
                                {
                                    this.state.load ? <Circular /> :
                                        <>
                                            <Button color="primary" onClick={this.onNovo}>Adicionar Novo</Button>
                                            <Table
                                                tableHeaderColor="primary"
                                                tableHead={["Nome", "E-mail", "Função", "ID", "Ação"]}
                                                tableData={this.state.data}
                                            />
                                        </>
                                }
                            </CardBody>
                        </Card> :
                        <>
                            {
                                this.state.load ? <Circular /> :
                                    <CardBody>
                                        <Table
                                            striped
                                            tableHeaderColor="primary"
                                            tableHead={["Nome", "E-mail", "Função", "ID", "Ação"]}
                                            tableData={this.state.data}
                                        />
                                    </CardBody>
                            }
                        </>
                }

                <Dialog
                    open={this.state.openModal}
                    onClose={() => { }}
                    aria-labelledby="responsive-dialog-title"
                    fullWidth={true}
                //maxWidth='lg'
                >
                    <DialogTitle id="responsive-dialog-title">{(this.state.showSave) ? ((this.state.id === '') ? 'Novo usuário' : 'Editar usuário') : ''}</DialogTitle>
                    <DialogContent>

                        <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                                <CustomInput
                                    labelText="E-mail *"
                                    id="email"
                                    value={this.state.email}

                                    inputProps={{
                                        value: this.state.email,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ email: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>


                            {
                                !this.state.modoEdit ?
                                    <GridItem xs={12} sm={12} md={6}>
                                        <CustomInput
                                            labelText="Senha *"
                                            id="senha"
                                            value={this.state.senha}
                                            type="password"
                                            autocomplete="off"
                                            inputProps={{
                                                value: this.state.senha,
                                                // disableAnimation: true,
                                                onChange: event => this.setState({ senha: event.target.value })
                                            }}
                                            formControlProps={{
                                                fullWidth: true,
                                                className: this.props.classes.inputMargin
                                            }}
                                        />
                                    </GridItem> : undefined
                            }

                            <GridItem xs={12} sm={12} md={6}>
                                <CustomInput
                                    labelText="ID"
                                    id="matricula"
                                    value={this.state.matricula}

                                    inputProps={{
                                        value: this.state.matricula,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ matricula: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={6}>
                                <TextField
                                    id="standard-select-currency"
                                    select
                                    label="Perfil"
                                    fullWidth
                                    disabled={this.state.modoEdit}
                                    className={this.props.classes.inputMargin}
                                    value={this.state.perfil}
                                    onChange={e => this.setState({ perfil: e.target.value })}
                                >
                                    {
                                        this.state.dataRoles.map((option, index) => {

                                            return (
                                                <MenuItem key={index} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </TextField>
                            </GridItem>

                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="Nome"
                                    id="nome"
                                    value={this.state.nome}

                                    inputProps={{
                                        value: this.state.nome,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ nome: event.target.value }),
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>


                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="CPF"
                                    id="cpf"
                                    value={this.state.cpf}

                                    inputProps={{
                                        value: this.state.cpf,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ cpf: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="Telefone Celular"
                                    id="telefone"
                                    value={this.state.telefone}

                                    inputProps={{
                                        value: this.state.telefone,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ telefone: event.target.value }),
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            {
                                !this.state.modoEdit ?
                                    <GridItem xs={12} sm={12} md={6}>
                                        <TextField
                                            id="standard-select-currency"
                                            select
                                            label="Lockers"
                                            fullWidth
                                            className={this.props.classes.inputMargin}
                                            value={this.state.lockers}
                                            onChange={e => {

                                                const item = this.state.dataLockers.filter(item => item.value === e.target.value)
                                                const existe = this.state.dataLockersGrid.filter(locker => locker.value === e.target.value)

                                                if (existe.length > 0) return

                                                this.setState({
                                                    dataLockersGrid: [...this.state.dataLockersGrid, ...item],
                                                    lockers: e.target.value
                                                })
                                            }}
                                        >
                                            {this.state.dataLockers.map((option, index) => (
                                                <MenuItem key={index} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </GridItem> : undefined
                            }

                        </GridContainer>

                        <div className={this.props.classes.divGrupos}>
                            {
                                !this.state.modoEdit ?
                                    <div className={this.props.classes.divItemGrupo}>
                                        <div className={this.props.classes.lockerVinculadoView}>
                                            <label>Lockers vinculados a este usuário</label>
                                        </div>
                                        {
                                            this.state.dataLockersGrid.map((locker, index) => {

                                                return (
                                                    <div key={index} className={!this.state.showSave ? this.props.classes.noButtonDeleteLockerUser : undefined}>
                                                        {
                                                            this.state.showSave ?
                                                                <IconButton aria-label="view" onClick={() => this.onDeleteItemGridLockersUser(locker)}>
                                                                    <Delete className={this.props.classes.iconView} />
                                                                </IconButton> : undefined
                                                        }
                                                        <label>
                                                            {locker.label}
                                                        </label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div> : undefined
                            }

                        </div>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onCancel}>
                            Cancelar
                        </Button>
                        {
                            this.state.showSave ?
                                <Button onClick={this.onSave} color="primary">
                                    Salvar
                            </Button> : undefined
                        }
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.openModalDelete}
                    onClose={() => this.setState({ openModalDelete: false, userDeleteSelected: undefined })}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">Deletar Usuário</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Este processo de deletar um usuário não pode ser desfeito, deseja continuar?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ openModalDelete: false })} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={() => this.onDelete()} color="primary">
                            Deletar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar open={this.state.showValidation} autoHideDuration={6000} onClose={() => this.setState({ showValidation: false })}>
                    <MuiAlert onClose={() => this.setState({ showValidation: false })} elevation={6} variant="filled" severity='error'>
                        Você não tem permissão para realizar esta ação
                    </MuiAlert>
                </Snackbar>

            </GridContainer>
        )
    }
}

const styles = theme => ({
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    iconView: {
        color: "gray !important"
    },
    iconViewArrow: {
        color: "white !important",
    },
    buttonIcon: {
        padding: "5px"
    },
    dropdown: {
        right: "1.5%",
        top: "24%",
        position: "absolute"
    },
    removeMarginFromTop: {
        margin: 0
    },
    inputMargin: {
        marginTop: 10
    },

    lockerVinculadoView: {
        display: 'flex',
        flex: 1,
        background: '#f8f8f8',
        marginTop: 10,
        padding: 10,
        borderRadius: 2,
        borderBottomWidth: 1,
        borderBottomColor: '#ECECEC'
    },
    noButtonDeleteLockerUser: {
        padding: 5
    },
    divGrupos: {
        display: 'flex',
        flexDirection: 'row'
    },
    divItemGrupo: {
        width: '50%'
    }
});

export default withStyles(styles)(Usuarios);
